const pagesUsersEn = {
  detail: {
    header: {
      viewMemberProfile: 'View member profile',
    },
    identity: {
      linked: 'Linked',
    },
    identityPageTitle: 'Account Info',
    sessions: {
      columns: {
        active: 'Status',
        activeFalse: 'Inactive',
        activeTrue: 'Active',
        authLevel: 'Auth Level',
        authMethods: 'Auth Methods',
        authenticatedAt: 'Authenticated At',
        devices: 'Devices',
        expiresAt: 'Expires At',
      },
      dialog: {
        authTimeline: 'Auth Timeline',
        deviceInfo: 'Device Info',
        ipAddress: 'IP Address',
        title: 'Session Detail',
        userAgent: 'User Agent',
      },
      filterActive: 'Active',
      filterAll: 'All',
      filterInactive: 'Inactive',
    },
    sessionsPageTitle: 'Sessions',
    syncWorkEmail: {
      currentAuthEmail: 'Current authentication email address',
      description:
        'Sync the authentication email address with the employee email address.',
      notificationNote:
        'A notification will be sent to both the previous and the new email address.',
      submit: 'Sync',
      success: 'Authentication email has been synced.',
      targetEmail: 'Employee email address (sync target)',
      title: 'Sync authentication email',
    },
    tabs: {
      identity: 'Account Info',
      sessions: 'Sessions',
    },
  },
};

export default pagesUsersEn;
